import HubPage from '../../components/HubPage';
export default function MarketingHub() { return <HubPage hubKey="marketing" />; }
